<template>
    <div class="foorerEnd">
        <div class="underside">
            <div class="underside_left">
                <p>网站首页 | 隐私声明 | 法律声明 | 使用帮助 | 关于我们</p>
                <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">
                    <p>{{ mediation }}<span>备案许可证编号：{{ filings }}</span></p>
                </a>
                <p>地址：{{ address }} <span>联系电话：{{ phone }}</span></p>
            </div>
            <div class="underside_right">
                <div class="underside_imag">
                    <img v-if="resolution == 1" src="../assets/image/cn.png" alt="">
                    <img v-if="resolution == 2" src="../assets/image/xy.png" alt="">
                    <img v-if="resolution == 3" src="../assets/image/tm.png" alt="">
                    <img v-if="resolution == 4" src="../assets/image/jd.png" alt="">
                    <img v-if="resolution == 5" src="../assets/image/dd.png" alt="">
                    <img v-if="resolution == 6" src="../assets/image/yx.png" alt="">
                    <img v-if="resolution == 7" src="../assets/image/zq.png" alt="">
                    <p>公众号</p>
                </div>
                <!-- <div class="underside_imag">
                    <img src="../assets/image/headbg.png" alt="">
                    <p>案件查询</p>
                </div> -->
            </div>
        </div>
    </div>
</template>
<script>
export default {
    // props:['mediation','address','phone'],
    data() {
        return {
            mediation: '',//调解中心
            filings: "冀ICP备2024060289号",//备案号
            address: '',//地址
            phone: '',
            resolution: ''
        }
    },
    mounted() {
        if (JSON.parse(sessionStorage.getItem("resolution"))) {
            this.resolution = JSON.parse(sessionStorage.getItem("resolution"))
            if (this.resolution == 1) {
                this.mediation = '常宁市数科纠纷调解中心';
                this.address = '常宁市'
                this.phone = '0734-7298911'
            }
            else if (this.resolution == 2) {
                this.mediation = '襄阳襄州网络金融纠纷调解中心';
                this.address = '襄阳市'
                this.phone = '0710-3337535'
            }
            else if (this.resolution == 3) {
                this.mediation = '天门市正合多元调解中心';
                this.address = '天门市'
                this.phone = '4009261971'
            }
            else if (this.resolution == 4) {
                this.mediation = '山西九鼎金融纠纷调解中心';
                this.address = '山西市'
                this.phone = '4008-916578'
            }
            else if (this.resolution == 5) {
                this.mediation = '荆门掇刀区商事仲裁调解服务中心';
                this.address = '荆门市'
                this.phone = '4009155317'
            }
            else if (this.resolution == 6) {
                this.mediation = '汉中市洋县桓天纠纷调解中心';
                this.address = '汉中市'
                this.phone = '0916-8216386'
            }
            else if (this.resolution == 7) {
                this.mediation = '枣强曙光商事调解中心';
                this.address = '衡水市'
                this.phone = '0318-8386118'
            }
        }
    }
}
</script>
<style lang="less" scoped>
.foorerEnd {
    width: 100%;
    height: 200px;
    margin-top: 100px;
    background-image: url(../assets/image/aubg.png);
    position: relative;

    .underside {
        width: 100%;
        height: 91px;
        padding: 16px 0;
        background-color: #BE1A0F;
        display: flex;
        justify-content: space-around;
        align-items: center;
        position: absolute;
        top: 60px;

        p {
            line-height: 30px;
            font-size: 14px;
            color: #fff;

            span {
                margin-left: 50px;
            }
        }

        .underside_right {
            display: flex;
            justify-content: center;
            align-items: center;

            .underside_imag {
                text-align: center;
                margin: 0 10px;

                img {
                    width: 72px;
                    height: 72px;
                }
            }
        }
    }

}

@media screen and (max-width: 1200px) {
    .foorerEnd {
        width: 100%;
        height: 250px;
        margin-top: 100px;
        background-image: url(../assets/image/aubg.png);
        position: relative;

        .underside {
            width: 100%;
            height: 200px;
            padding: 16px 0;
            background-color: #be1a0f;
            display: flex;
            justify-content: space-around;
            align-items: center;
            flex-direction: column;
            position: absolute;
            top: 0px;

            p {
                line-height: 30px;
                font-size: 10px;
                color: #fff;

                span {
                    margin-left: 50px;
                }
            }

            .underside_right {
                display: flex;
                justify-content: center;
                align-items: center;

                .underside_imag {
                    text-align: center;
                    margin: 0 10px;

                    img {
                        width: 72px;
                        height: 72px;
                    }
                }
            }
        }
    }
}
</style>
